import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class User extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  getGroupPriceUser(params) {
    return this.httpService.get("Accounts/combo-group-user-price", {
      headers,
      params,
    });
  }
  getNameUserDefault(params) {
    return this.httpService.get("Accounts/username-default", {
      headers,
      params,
    });
  }
  selectUserGroup(params) {
    return this.httpService.get("Acounts/select-user-group", {
      headers,
      params,
    });
  }

  editUser(data) {
    return this.httpService.put("Accounts/update-user-agent", data, {
      headers,
    });
  }

  postInsertUser(data) {
    return this.httpService.post("Accounts/register-User-agent", data, {
      headers,
    });
  }

  deleteUser(data) {
    return this.httpService.delete("Accounts/delete-user", { headers, data });
  }

  selectStypeUserGroup(params) {
    return this.httpService.get("Acounts/select-stype-user-group", {
      headers,
      params,
    });
  }

  activeAction(data) {
    return this.httpService.put("Accounts/update-user-active", data, {
      headers,
    });
  }

  getAccessData(params) {
    return this.httpService.get("Acounts/list-access-user", {
      headers,
      params,
    });
  }

  postAccessID(data) {
    return this.httpService.post("Acounts/register-access-user", data, {
      headers,
    });
  }

  getAllGoroupUserData(params) {
    return this.httpService.get("Accounts/get-all-group-user-price", {
      headers,
      params,
    });
  }

  insertGoroupUserPriceData(data) {
    return this.httpService.post("Accounts/insert-group-user-price", data, {
      headers,
    });
  }

  updateGoroupUserData(data) {
    return this.httpService.put("Accounts/update-group-user-price", data, {
      headers,
    });
  }

  deleteGoroupUserData(data) {
    return this.httpService.delete("Accounts/delete-group-user-price", {
      headers,
      data: data,
    });
  }

  getRelationGoroupUserData(params) {
    return this.httpService.get("Accounts/relation-group-user-price", {
      headers,
      params,
    });
  }

  getComboStypePanel(params) {
    return this.httpService.get("Accounts/combo-stype-panel", {
      headers,
      params,
    });
  }

  getAllGroupModelFactors(params) {
    return this.httpService.get("Account/all-group-model-factor", {
      headers,
      params,
    });
  }

  registerModelFactor(data) {
    return this.httpService.post("Account/register-model-factor", data, {
      headers,
    });
  }

  getListActiveModelFactor(params) {
    return this.httpService.get("Account/list-active-model-factor", {
      headers,
      params,
    });
  }

  deleteUserInfo(data) {
    return this.httpService.delete("Accounts/delete-user-info", { headers, data });
  }

  postAccessFactor(data) {
    return this.httpService.post("Acounts/register-access-factor-user", data, {
      headers,
    });
  }

  getSupervisorData(params) {
    return this.httpService.get("Accounts/combo-supervisor", {
      headers,
      params,
    });
  }
  getAgentData(params) {
    return this.httpService.get("Accounts/combo-agent-transfer", {
      headers,
      params,
    });
  }
  getGroupedAgents(params) {
    return this.httpService.get("Accounts/list-agent-sub-supervisor", {
      headers,
      params,
    });
  }
  getUnGroupedAgents(params) {
    return this.httpService.get("Accounts/list-agent-free", {
      headers,
      params,
    });
  }
  postTransferAgentSupervisor(data) {
    return this.httpService.post("Accounts/register-agent-transfer-supervisor", data, {
      headers,
    });
  }

  postTransferAgent(data) {
    return this.httpService.post("Accounts/transfer-agent-subset-supervisor", data, {
      headers,
    });
  }

}
const UserService = new User();
export default UserService;
